import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p><strong>Description</strong></p>
     <p>Departing is the action of physically and virtually moving all staged containers onto the correct VRID. The goal for this metric is >95%. Stations should be utilizing SCC to ensure that containers are departing in alignment with the assigned CPT for the container.</p>
     <p><strong>Resolution Steps:</strong></p>
     <ol>
        <li>Navigate to <a href="https://logistics.amazon.com/station/dashboard/containerSummary">SCC reverse tab</a> to identify any containers that are pending depart within the next hour based off CPT.</li>
        <li>Identify available outbound VRIDs through <a href="https://trans-logistics.amazon.com/fmc/execution/">freight management console.</a></li>
        <li>If VRID is not available request a VRID using the following <a href="https://sim.amazon.com/issues/create?assignedFolder=3525db99-a22d-42bd-99d1-d2b792f30b69">SIM</a></li>
        <li>If there are any issues with line-haul delays or having drivers accept VRID please send an escalation to the following alias: reactivescheduling-warehousetransfers-relotransfers@amazon.com</li>
     </ol>
     <p><strong>Supplemental Links</strong></p>
     <ol>
        <li><span class="wikiinternallink"><a href="https://start.wwops.amazon.dev/boards/browse?boardId=IjI2MDIzIg%3D%3D&businessUnitId=IjMi&selectedTagValueIds=WyIzMDMiLCIzMzIwIiwiMzMyMiJd&topLevelFilters=eyI0IjoiNDEiLCI2IjoiNDkifQ%3D%3D#26023">Reverse Logistics URL START Page</a></span></li>
        <li><span class="wikiinternallink"><a href="https://w.amazon.com/bin/view/NA_AMZL_ACES/LMDX/Reverse_Logistics">Reverse Logistics URL WIKI</a></span></li>
     </ol>
     <p><strong>RACI</strong></p>
     <img src="https://w.amazon.com/bin/download/Stratos/Internal/MBEDashboard/ExceptionSOP/AMZLStations_Multiday_Stow_Alert/WebHome/Screenshot%202024-11-14%20at%201.36.45%E2%80%AFPM.png?width=1162&height=401" height="288" width="834" alt="RACI" />
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_On_Time_Depart_Alert.jsx